declare namespace $ {

	type $mol_view__sub_shm_knowledge_manual_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_check_icon__hint_shm_knowledge_manual_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_icon['hint'] >
	>
	type $mol_check_icon__enabled_shm_knowledge_manual_3 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['edit_enabled'] >
		,
		ReturnType< $mol_check_icon['enabled'] >
	>
	type $mol_check_icon__checked_shm_knowledge_manual_4 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['editing'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_knowledge_manual_5 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['Edit_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	type $mol_page__title_shm_knowledge_manual_6 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['text_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_content_shm_knowledge_manual_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__body_shm_knowledge_manual_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_knowledge_manual_editor__api_url_shm_knowledge_manual_9 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['api_url'] >
		,
		ReturnType< $shm_knowledge_manual_editor['api_url'] >
	>
	type $shm_knowledge_manual_editor__api_headers_shm_knowledge_manual_10 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['api_headers'] >
		,
		ReturnType< $shm_knowledge_manual_editor['api_headers'] >
	>
	type $shm_knowledge_manual_editor__kind_shm_knowledge_manual_11 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['kind'] >
		,
		ReturnType< $shm_knowledge_manual_editor['kind'] >
	>
	type $shm_knowledge_manual_editor__title_shm_knowledge_manual_12 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['editor_title'] >
		,
		ReturnType< $shm_knowledge_manual_editor['title'] >
	>
	type $shm_knowledge_manual_editor__saved_shm_knowledge_manual_13 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['document_saved'] >
		,
		ReturnType< $shm_knowledge_manual_editor['saved'] >
	>
	type $shm_knowledge_manual_editor__close_shm_knowledge_manual_14 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['editor_close'] >
		,
		ReturnType< $shm_knowledge_manual_editor['close'] >
	>
	type $shm_knowledge_manual_editor__baseline_shm_knowledge_manual_15 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['editor_baseline'] >
		,
		ReturnType< $shm_knowledge_manual_editor['baseline'] >
	>
	type $shm_knowledge_manual_editor__draft_shm_knowledge_manual_16 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['editor_draft'] >
		,
		ReturnType< $shm_knowledge_manual_editor['draft'] >
	>
	type $mol_link__arg_shm_knowledge_manual_17 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['toc_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__uri_toggle_shm_knowledge_manual_18 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['toc_uri'] >
		,
		ReturnType< $mol_link['uri_toggle'] >
	>
	type $mol_link__sub_shm_knowledge_manual_19 = $mol_type_enforce<
		ReturnType< $shm_knowledge_manual['toc_link_content'] >
		,
		ReturnType< $mol_link['sub'] >
	>
	export class $shm_knowledge_manual extends $shm_hitalama_textbook {
		manual_pages( ): readonly($mol_view)[]
		Document_title( ): $mol_view
		edit_enabled( ): boolean
		editing( next?: boolean ): boolean
		Edit_icon( ): $mol_icon_pencil
		Edit_toggle( ): $mol_check_icon
		editor_title( id: any): string
		document_saved( id: any, next?: any ): any
		editor_close( next?: any ): any
		editor_baseline( id: any, next?: any ): any
		editor_draft( id: any, next?: string ): string
		heading_param( ): string
		toc_arg( id: any): Record<string, any>
		toc_uri( id: any): string
		toc_link_content( id: any): readonly($mol_view_content)[]
		kind( ): string
		api_url( ): string
		api_headers( ): Record<string, any>
		pages( ): ReturnType< $shm_knowledge_manual['manual_pages'] >
		Text_page( ): $mol_page
		Editor( id: any): $shm_knowledge_manual_editor
		text_param( ): ReturnType< $shm_knowledge_manual['heading_param'] >
		Toc_link( id: any): $mol_link
		Project_icon( id: any): $mol_icon_apps
		Common_icon( ): $mol_icon_folder
	}
	
}

//# sourceMappingURL=manual.view.tree.d.ts.map